module.exports = "/_next/static/images/favicon-16-caf69127d7240c0f5752a10f52509e64.png";